import { Accordion } from "@mantine/core";
import styles from "./AccordionComponents.module.css";

type AccordionSectionProps = {
    title: string;
    children: React.ReactNode;
};

export function AccordionSection({ title, children }: AccordionSectionProps) {
    return (
        <Accordion.Item value={title} key={title}>
            <Accordion.Control>
                <div className={styles.sectionTitle}>{title}</div>
            </Accordion.Control>
            {children}
        </Accordion.Item>
    );
}
